import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import { HelpMessage } from 'utils/constants'

const CreateEditFormItems: React.VFC = () => {
  return (
    <>
      <NameFormItem help={HelpMessage.Name} />
      <DescriptionFormItem entityName="Type" />
    </>
  )
}

export default CreateEditFormItems
